'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactIntlTelInput = require('react-intl-tel-input');var _reactIntlTelInput2 = _interopRequireDefault(_reactIntlTelInput);
var _reactRedux = require('react-redux');
var _reduxForm = require('redux-form');
var _ramda = require('ramda');
var _reduxPagan = require('redux-pagan');
var _reactRouter = require('react-router');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('../../components');










var _ConfirmPhoneModal = require('./ConfirmPhoneModal');var _ConfirmPhoneModal2 = _interopRequireDefault(_ConfirmPhoneModal);
var _AgentAdditionalFields = require('./AgentAdditionalFields');var _AgentAdditionalFields2 = _interopRequireDefault(_AgentAdditionalFields);
var _PasswordsBlock = require('./PasswordsBlock');var _PasswordsBlock2 = _interopRequireDefault(_PasswordsBlock);
var _UsernameBlock = require('./UsernameBlock');var _UsernameBlock2 = _interopRequireDefault(_UsernameBlock);
var _EmailPhoneBlock = require('./EmailPhoneBlock');var _EmailPhoneBlock2 = _interopRequireDefault(_EmailPhoneBlock);

var _messageModal = require('../../redux/modules/messageModal');
var _userAuthentication = require('../../redux/modules/userAuthentication');




var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);
var _getFullName = require('../../helpers/getFullName');var _getFullName2 = _interopRequireDefault(_getFullName);
var _constants = require('../../constants');
var _validate = require('../../utils/validate');
var _checkers = require('../../utils/checkers');
var _validate2 = require('./validate');var _validate3 = _interopRequireDefault(_validate2);
var _constants2 = require('./constants');var _constants3 = _interopRequireDefault(_constants2);

var _RegistrationContainer = require('./RegistrationContainer.scss');var styles = _interopRequireWildcard(_RegistrationContainer);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Redux
// Helper
// Styles
var RegistrationContainer = function (_Component) {_inherits(RegistrationContainer, _Component);function RegistrationContainer() {var _temp, _this, _ret;_classCallCheck(this, RegistrationContainer);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { showError: false, passwordIsValid: false,
      captcha: null,
      emailIsValid: false,
      phoneIsValid: false,
      isFirstValue: false,
      isCodeModalOpen: false,
      countryData: _constants.israelCode,
      isShowCoupon: false,
      resendCounter: 0,
      timerTimeLeft: 0,
      isTimerRunning: false,
      isResendForm: false }, _this.

















    onSelectFlag = function (_, countryData) {
      _this.setState({ countryData: countryData.dialCode });
    }, _this.

    getCorrectPhone = function (phone, countryData) {
      if (!phone) {
        return '';
      }
      return countryData === _constants.israelCode && phone.startsWith('0') ?
      phone.slice(1) :
      phone;
    }, _this.

    setWrapperRef = function (node) {
      _this.formRef = node;
    }, _this.

    toggleCodeModal = function () {
      _this.setState(function (prevState) {return { isCodeModalOpen: !prevState };});
    }, _this.

    showCorrectPhone = function (phone, countryData) {
      if (!phone) {
        return '';
      }
      var correctPhone = countryData === _constants.israelCode && phone.startsWith('0') ?
      phone.slice(1) :
      phone;
      var correctCode = countryData === _constants.israelCode ?
      '0' :
      countryData;
      return '' + correctCode + correctPhone;
    }, _this.

    startTimer = function () {
      clearInterval(_this.resendTimer);
      _this.resendTimer = setInterval(function () {
        _this.setState(function (prevState) {
          if (prevState.timerTimeLeft <= 1) {
            clearInterval(_this.resendTimer);
            return { timerTimeLeft: 0, isTimerRunning: false };
          }
          return { timerTimeLeft: prevState.timerTimeLeft - 1 };
        });
      }, 1000);
    }, _this.

    submitForm = function (value, isResendForm) {var _this$props =
      _this.props,isRegistrationCheckPhone = _this$props.isRegistrationCheckPhone,locale = _this$props.locale;var _this$state =
      _this.state,captcha = _this$state.captcha,countryData = _this$state.countryData;var

      email =








      value.email,phone = value.phone,password = value.password,first_name = value.first_name,last_name = value.last_name,isAgentCheckbox = value.isAgentCheckbox,license_number = value.license_number,company_name = value.company_name,code = value.code;
      var link = (0, _get2.default)(value, 'logo.link');
      var angle = (0, _get2.default)(value, 'logo.angle');
      var phoneNumberData = _this.getCorrectPhone(phone, countryData);

      var data = Object.assign({
        email: email,
        password: password,
        captcha: captcha,
        phone: '+' + countryData + phoneNumberData,
        first_name: (0, _getFullName2.default)(first_name, last_name),
        is_agent: isAgentCheckbox,
        license_number: license_number,
        company_name: company_name },
      isAgentCheckbox ? { profile_img: { link: link, angle: angle } } : {});


      if (!_this.state.isCodeModalOpen) {
        var error = _this.props.userAuthentication && _this.props.userAuthentication.error;
        if (_this.state.isTimerRunning && (!error || !error.status)) {
          _this.setState({ isCodeModalOpen: true });
          return;
        }

        var initRegistrationData = Object.assign({},
        data, {
          locale: locale });

        _this.props.initRegistration(initRegistrationData);
        _this.setState({
          captcha: null,
          resendCounter: 0,
          isTimerRunning: true,
          timerTimeLeft: 61 });

        _this.startTimer();
      } else if (isResendForm) {
        var _initRegistrationData = Object.assign({},
        data, {
          locale: locale });

        _this.props.initRegistration(_initRegistrationData);
        _this.setState(function (prevState) {return {
            captcha: null,
            resendCounter: prevState.resendCounter + 1,
            isTimerRunning: prevState.resendCounter < 3,
            timerTimeLeft: prevState.resendCounter < 3 ? 61 : 0 };});

        _this.startTimer();
      } else if (_this.state.isCodeModalOpen) {
        var completeRegistrationData = Object.assign({},
        data, {
          code: code });


        _this.props.completeRegistration(completeRegistrationData);
        _this.setState({ captcha: null });
      }
    }, _this.

    handleSubmit = function (evt, isResendForm) {
      _this.setState({ isResendForm: isResendForm });
      _this.props.handleSubmit(function (value) {return _this.submitForm(value, isResendForm);})(evt);
      return true;
    }, _this.

    fetchReCaptchaToken = function (evt, isResendForm) {
      _this.setState({ captcha: evt }, function (value) {return _this.handleSubmit(value, isResendForm);});
    }, _this.

    showCoupon = function () {
      _this.setState({ isShowCoupon: true });
    }, _this.

    validatePassword = function (password) {
      var result = (0, _validate.passwordValidation)(password);
      _this.setState({ passwordIsValid: result });

      return result;
    }, _this.

    validationMark = function (isInvalid) {return _this.setState({ showError: isInvalid });}, _this.

    validateEmail = function (value) {
      var email = value.replace(/\s/g, '');

      var emailIsValid = (0, _validate.emailRegexValidation)(email);
      var phoneIsValid = (0, _validate.phoneRegexValidation)(value.replace(/\s/g, ''));
      var result = false;var
      modalType = _this.props.userAuthentication.authenticationModalType;
      var temporaryModal = modalType === _constants.authenticationModalType.UPDATE_TEMPORARY_PROFILE;

      if (emailIsValid || phoneIsValid) {
        result = true;
      } else if (!result) {
        result = false;
      } else if (temporaryModal) {
        result = _this.props.userAuthentication.data.email !== email && !(0, _checkers.isTemporaryEmail)(email);
      }

      _this.setState(Object.assign({
        emailIsValid: result ? emailIsValid : false,
        phoneIsValid: result ? phoneIsValid : false },
      temporaryModal && { isTemporaryEmail: (0, _checkers.isTemporaryEmail)(email) }));


      return result;
    }, _this.

    changeImages = function (data) {
      var publicId = null;
      var full = null;
      var image = data.length ? data[0] : {};

      if (data.length) {
        publicId = image.public_id ? image.public_id : image.full && image.full.split('/').pop();
        full = image.full;
      }

      var userImage = {
        link: publicId,
        angle: image.angle || 0,
        full: full };


      _this.setState({ isChangeImg: true });
      _this.props.changeValue('logo', userImage);
    }, _this.

    defineEmailErrorMsg = function () {
      var errorMsg = '';

      if (_this.state.isTemporaryEmail) {
        errorMsg = _this.props.translate('authenticationPage', 'errorMessageForTemporaryUser');
      } else if (!_this.state.emailIsValid) {
        errorMsg = _this.props.translate('authenticationPage', 'emailTooltipMessage');
      } else {var
        error = _this.props.userAuthentication.error;
        errorMsg = error && (error.name === 'BadRequestError' || error.message.match(/email/i)) ?
        _this.props.translate('authenticationPage', 'errorMessage') :
        '';
      }

      return errorMsg.toString();
    }, _this.

    uploadWidget = function (_ref) {var _cx;var meta = _ref.meta;return (
        _react2.default.createElement('div', { className: styles.widget },
          _react2.default.createElement(_components.UploadAssetWidget, {
            openMessageModal: _this.props.openMessageModal,
            className: (0, _classnames2.default)((_cx = {}, _cx[styles.inputLogo] = !_this.props.isMobile, _cx['has-error-form'] = !!meta.error && meta.touched, _cx)),
            translate: _this.props.translate('uploadWidget'),
            rootTranslate: _this.props.translate,
            isMobile: _this.props.isMobile,
            uploadInProgress: function uploadInProgress(status) {return _this.setState({ uploadPhotoInProgress: status });},
            updateContent: _this.changeImages,
            contentUploaded: _this.changeImages,
            suspendedUpload: true,
            userToken: _this.props.userToken })));}, _this.




    renderResendButton = function () {
      var withCaptcha = _this.state.captcha;
      var loadingUserData = _this.props.userAuthentication && _this.props.userAuthentication.loading;
      var disabled = _this.state.isTimerRunning || _this.state.resendCounter >= 3 || loadingUserData;var
      translate = _this.props.translate;

      if (_this.state.resendCounter >= 3) {
        return (
          _react2.default.createElement(_components.ResendLimitExceededMessage, { className: styles.resendLimitMessage, translate: translate }));

      }
      return (
        _react2.default.createElement('div', { style: {
              display: 'flex',
              justifyContent: 'center',
              gap: '30px',
              marginTop: '15px',
              alignItems: 'center' } },


          _this.state.resendCounter < 3 && _this.state.isTimerRunning &&
          _react2.default.createElement(_components.ResendTimerMessage, { translate: translate, timeLeft: _this.state.timerTimeLeft }),

          _react2.default.createElement('div', { className: styles.buttonWrapper },
            !withCaptcha ?
            _react2.default.createElement(_components.GoogleReCaptcha, {
                locale: _this.props.locale,
                fetchToken: function fetchToken(evt) {return _this.fetchReCaptchaToken(evt, true);},
                captchaIdentifier: 'resendRegistrationForm',
                doReset: loadingUserData,
                userAuthentication: true },

              _react2.default.createElement(_components.ResendButton, {
                isLoading: loadingUserData,
                disabled: disabled,
                translate: translate,
                isTimerRunning: _this.state.isTimerRunning,
                onClick: _this.state.captcha && function (evt) {return _this.handleSubmit(evt, true);} })) :



            _react2.default.createElement(_components.ResendButton, {
              isLoading: loadingUserData,
              disabled: disabled,
              translate: translate,
              isTimerRunning: _this.state.isTimerRunning,
              onClick: function onClick(evt) {return _this.handleSubmit(evt, true);} }))));





    }, _this.

    renderButton = function (captchaIdentifier) {
      var withCaptcha = _this.state.captcha;
      var loadingUserData = _this.props.userAuthentication && _this.props.userAuthentication.loading;
      return (
        _react2.default.createElement('div', { className: styles.buttonWrapper },
          !withCaptcha ?
          _react2.default.createElement(_components.GoogleReCaptcha, {
              locale: _this.props.locale,
              fetchToken: _this.fetchReCaptchaToken,
              captchaIdentifier: captchaIdentifier,
              doReset: loadingUserData,
              userAuthentication: true },

            _react2.default.createElement(_components.AuthorizationButton, {
                onClick: _this.state.captcha && _this.handleSubmit,
                isLoading: loadingUserData },

              _this.props.translate('authenticationPage', 'submit'))) :



          _react2.default.createElement(_components.AuthorizationButton, {
              onClick: _this.handleSubmit,
              isLoading: loadingUserData },

            _this.props.translate('authenticationPage', 'submit'))));




    }, _this.

    renderInput = function (data) {var
      input = data.input,placeholder = data.placeholder,type = data.type,_data$meta = data.meta,touched = _data$meta.touched,error = _data$meta.error,active = _data$meta.active;
      return (
        _react2.default.createElement('span', null,
          _react2.default.createElement('input', _extends({
            className: (0, _classnames2.default)({ 'has-error': error && !active && touched, touched: touched }, 'form-control') },
          input, {
            placeholder: (placeholder || '').replace('*', ''),
            type: type })),

          touched &&
          error && _react2.default.createElement('span', { className: styles.required }, _this.props.translate('errorFieldMessages', error))));


    }, _this.

    renderEmailInput = function () {var _cx2;
      var handleChange = function handleChange(evt) {var
        value = evt.target.value;
        var isEmpty = !value || value && value.length === 0;
        var trimmedValue = value ? value.replace(/\s/g, '') : '';

        var emailIsValid = (0, _validate.emailRegexValidation)(trimmedValue);
        var phoneIsValid = (0, _validate.phoneRegexValidation)(trimmedValue);

        _this.setState(function (prev) {return Object.assign({},
          prev, {
            isFirstValue: !!value.length,
            captcha: !phoneIsValid ? null : prev.captcha,
            emailIsValid: isEmpty ? false : emailIsValid,
            phoneIsValid: isEmpty ? false : phoneIsValid });});

      };

      return (
        _react2.default.createElement('div', {
            className: (0, _classnames2.default)((_cx2 = {}, _cx2[
            styles.phoneInput] = _this.state.phoneIsValid || !_this.state.isFirstValue, _cx2)),

            ref: function ref(email) {_this.email = email;} },

          _react2.default.createElement(_components.OMInputField, {
            isForm: true,
            translate: _this.props.translate,
            name: _constants3.default.EMAIL,
            type: 'text',
            placeholder: '' + _this.props.translate('authenticationPage', 'emailField'),
            title: _this.defineEmailErrorMsg(),
            isInvalid: !!(_this.defineEmailErrorMsg() && _this.state.showError) || false,
            showHoverTooltip: false,
            fieldIsDirty: function fieldIsDirty(isDirty) {return _this.setState(function (prev) {return Object.assign({}, prev, { emailFieldIsDirty: isDirty });});},
            isMobile: _this.props.isMobile,
            onChange: handleChange,
            isValidIfEmpty: true,
            isRtl: _this.props.isRtl,
            validationMark: _this.validationMark,
            showErrorMessageDesktop: true })));



    }, _this.

    renderPasswordInput = function (name) {return (
        _react2.default.createElement('div', null,
          _react2.default.createElement(_components.OMInputField, {
            isForm: true,
            translate: _this.props.translate,
            name: name,
            type: 'password',
            placeholder: '' + _this.props.translate('authenticationPage', 'passwordFieldPlaceholder'),
            title: '' + _this.props.translate('authenticationPage', 'passwordTitle'),
            validate: _this.validatePassword,
            showHoverTooltip: !_this.state.passwordIsValid,
            tooltipMessage: '' + _this.props.translate('authenticationPage', 'passwordTooltipMessage'),
            fieldIsDirty: function fieldIsDirty(isDirty) {return _this.setState(function (prev) {return Object.assign({}, prev, { passwordFieldIsDirty: isDirty });});},
            isMobile: _this.props.isMobile,
            hidePasswordTitle: '' + _this.props.translate('authenticationPage', 'hidePassword'),
            revealPasswordTitle: '' + _this.props.translate('authenticationPage', 'revealPassword'),
            isValidIfEmpty: true,
            isRtl: _this.props.isRtl,
            showErrorMessageDesktop: true })));}, _this.




    renderAgreeCheckbox = function (data) {var
      input = data.input,_data$meta2 = data.meta,touched = _data$meta2.touched,error = _data$meta2.error,active = _data$meta2.active;

      return (
        _react2.default.createElement('div', { className: styles.formLink },
          _react2.default.createElement(_components.OMCheckbox, {
            id: 'agree',
            field: Object.assign({}, input, { checked: input.value }),
            notValid: touched && error && !active,
            label:
            _react2.default.createElement('span', null,
              _react2.default.createElement('span', null, _this.props.translate('authenticationPage', 'confirmThatIRead')), '\xA0',

              _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(_this.props.locale, '/terms'), target: '_blank' },
                _this.props.translate('authenticationPage', 'termsOfUse')), '\xA0',


              _react2.default.createElement(_reactRouter.Link, { to: (0, _appendLocale2.default)(_this.props.locale, '/privacy'), target: '_blank' },
                _this.props.translate('authenticationPage', 'privacy'))) })));






    }, _this.

    renderAgentCheckbox = function (_ref2) {var input = _ref2.input;return (
        _react2.default.createElement('div', { className: styles.agentCheckbox },
          _react2.default.createElement(_components.OMCheckbox, {
            id: 'isAgent',
            label:
            _react2.default.createElement('span', null,
              _react2.default.createElement('span', null, _this.props.translate('authenticationPage', 'professionalConfirmation'))),


            field: Object.assign({}, input, { checked: input.value }) })));}, _this.




    renderPhoneNumber = function (_ref3) {var input = _ref3.input,_ref3$meta = _ref3.meta,error = _ref3$meta.error,touched = _ref3$meta.touched;return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.inputPhone, { 'has-error': error && touched }) },
          _react2.default.createElement(_reactIntlTelInput2.default, {
            autoPlaceholder: false,
            nationalMode: false,
            containerClassName: (0, _classnames2.default)('intl-tel-input', styles.countrySelect),
            inputClassName: 'form-control phone-input',
            fieldName: 'phone_number',
            value: input.value,
            preferredCountries: _constants.PREFERRED_COUNTRIES,
            onPhoneNumberChange: function onPhoneNumberChange(_, value) {
              input.onChange(value);
            },
            onSelectFlag: _this.onSelectFlag,
            useMobileFullscreenDropdown: false,
            separateDialCode: true }),

          error && touched &&
          _react2.default.createElement('span', { className: styles.required },
            _this.props.translate('errorFieldMessages', 'phone-number'))));}, _this.





    renderSocialAuthentication = function () {return (
        _react2.default.createElement('div', { className: styles.socialAuthenticationWrapper },
          _react2.default.createElement(_components.SocialNetworkAuthentication, {
            className: 'UserAuthenticationSocialNetwork',
            isNewDesign: true,
            size: 26,
            translate: _this.props.translate('userAuthentication'),
            socialNetworkAuthentication: _this.props.socialNetworkAuthentication,
            isMobile: _this.props.isMobile })));}, _temp), _possibleConstructorReturn(_this, _ret);}RegistrationContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {var userAuthentication = newProps.userAuthentication,isRegistrationCheckPhone = newProps.isRegistrationCheckPhone;if (userAuthentication.loaded && isRegistrationCheckPhone && isRegistrationCheckPhone !== this.props.isRegistrationCheckPhone) {this.setState({ isCodeModalOpen: true });}};RegistrationContainer.prototype.componentWillUnmount = function componentWillUnmount() {clearInterval(this.resendTimer);};RegistrationContainer.prototype.




  render = function render() {var _this2 = this;var _props =
    this.props,translate = _props.translate,locale = _props.locale,fields = _props.fields,isRtl = _props.isRtl;var _state =
    this.state,isCodeModalOpen = _state.isCodeModalOpen,countryData = _state.countryData;

    return (
      _react2.default.createElement('div', { className: styles.container },
        _react2.default.createElement('form', { onSubmit: this.handleSubmit, ref: this.setWrapperRef },
          _react2.default.createElement(_EmailPhoneBlock2.default, {
            translate: translate,
            renderEmailInput: this.renderEmailInput,
            renderPhoneInput: this.renderPhoneNumber,
            isRtl: isRtl }),

          _react2.default.createElement(_UsernameBlock2.default, { translate: translate, renderInput: this.renderInput }),
          _react2.default.createElement(_PasswordsBlock2.default, {
            translate: translate,
            renderPasswordInput: this.renderPasswordInput }),

          _react2.default.createElement('hr', null),
          _react2.default.createElement('div', { className: styles.columnBlock },
            _react2.default.createElement(_reduxForm.Field, {
              name: _constants3.default.IS_AGENT_CHECKBOX,
              props: { locale: this.props.locale },
              component: this.renderAgentCheckbox })),


          fields.isAgentCheckbox &&
          _react2.default.createElement(_AgentAdditionalFields2.default, {
            locale: locale,
            translate: translate,
            renderInput: this.renderInput,
            uploadWidget: this.uploadWidget }),







          _react2.default.createElement('div', { className: styles.columnBlock },
            _react2.default.createElement(_reduxForm.Field, {
              name: _constants3.default.AGREE,
              props: { locale: this.props.locale },
              component: this.renderAgreeCheckbox })),


          this.renderButton('userRegistrationForm'),






          _react2.default.createElement(_ConfirmPhoneModal2.default, {
              translate: translate,
              isOpen: isCodeModalOpen,
              onClose: this.toggleCodeModal,
              phone: this.showCorrectPhone(fields.phone, countryData),
              renderInput: this.renderInput,
              validateInputValue: function validateInputValue(value) {
                if (_this2.state.isResendForm && (!value || !value.length)) {
                  return undefined;
                }
                return value && value.length === 4 ? undefined : 'length-code';
              } },

            this.renderButton('userRegistrationCode'),
            this.renderResendButton()))));




  };return RegistrationContainer;}(_react.Component);


RegistrationContainer.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string.isRequired,
  isMobile: _propTypes2.default.bool,
  fields: _propTypes2.default.object,
  userAuthentication: _propTypes2.default.object,
  sendContactUsForm: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  switchAuthModalType: _propTypes2.default.func,
  userData: _propTypes2.default.object,
  isMessageModalOpen: _propTypes2.default.bool,
  validatePassword: _propTypes2.default.func,
  usage: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  isRegistrationCheckPhone: _propTypes2.default.bool,
  isContactUsModalOpen: _propTypes2.default.bool,
  hideContactUsModal: _propTypes2.default.func,
  authenticateUser: _propTypes2.default.func,
  openAuthenticationModal: _propTypes2.default.func,
  socialNetworkAuthentication: _propTypes2.default.func,
  authenticateUserByNumber: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  checkPhone: _propTypes2.default.func,
  changeValue: _propTypes2.default.func,
  initRegistration: _propTypes2.default.func,
  completeRegistration: _propTypes2.default.func,
  isPageForRealtor: _propTypes2.default.bool,
  userToken: _propTypes2.default.string };


var selector = (0, _reduxForm.formValueSelector)('registrationForm');
var changeValue = function changeValue(name, value) {return (0, _reduxForm.change)('registrationForm', name, value);};

var mapStateToProps = function mapStateToProps(state) {return {
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    userToken: (0, _get2.default)(state, 'userAuthentication.data.access_token'),
    isMobile: state.windowDimentions.isMobile,
    userData: state.userAuthentication.data,
    isRegistrationCheckPhone: state.userAuthentication.isRegistrationCheckPhone,
    userAuthentication: state.userAuthentication,
    fields: {
      email: selector(state, _constants3.default.EMAIL),
      phone: selector(state, _constants3.default.PHONE),
      password: selector(state, _constants3.default.PASSWORD),
      repeatPassword: selector(state, _constants3.default.REPEAT_PASSWORD),
      firstName: selector(state, _constants3.default.FIRST_NAME),
      lastName: selector(state, _constants3.default.LAST_NAME),
      isAgentCheckbox: selector(state, _constants3.default.IS_AGENT_CHECKBOX),
      logo: selector(state, _constants3.default.LOGO),
      companyName: selector(state, _constants3.default.COMPANY_NAME),
      licenseNumber: selector(state, _constants3.default.LICENSE_NUMBER),
      coupon: selector(state, _constants3.default.COUPON),
      agree: selector(state, _constants3.default.AGREE),
      code: selector(state, _constants3.default.CODE) } };};



var mapDispatchToProps = {
  changeValue: changeValue,
  openMessageModal: _messageModal.openMessageModal,
  hideMessageModal: _messageModal.hideMessageModal,
  initRegistration: _userAuthentication.initRegistration,
  completeRegistration: _userAuthentication.completeRegistration };exports.default =


(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps),
(0, _reduxForm.reduxForm)({
  form: 'registrationForm',
  validate: _validate3.default }))(

RegistrationContainer);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/RegistrationContainer/RegistrationContainer.js
// module id = 1260
// module chunks = 0